export default __webpack_public_path__ + "static/ashley-d5e3c48f4d42699b0990d7f604d34f3d.jpg";